export class MakePublicPaymentRequest {
    paymentType: number;

    payeeName: string;
    companyName: string;
    memo: string;
    phoneNumber: string;
    email: string;
    reason: string;
    invoiceNumber: string;
    paymentAmount: number;

    cardNumber: string;
    cardExpiration: string;
    cvv: string;
    billingStreet: string;
    billingStreet2: string;
    billingCity: string;
    billingState: string;
    billingZip: string;

    nameOnAccount: string;
    routingNumber: string;
    accountNumber1: string;
    accountNumber2: string;

    password1: string;
    password2: string;
}
